module.exports = __webpack_public_path__ + "static/media/Interning.4c2dd704.png";